import { SET_LATLNG, SET_ZOOM, GET_BRANCHES } from '../actions/store-location/type';

const initState = { latlng: { lat: 13.745206, lng: 100.533331, zoom: 18 }, branches: null }
export default function (state = initState, action) {
    switch (action.type) {
        case SET_LATLNG:
            return { ...state, latlng: action.payload }
        case SET_ZOOM:
            return { ...state, zoom: action.payload }
        case GET_BRANCHES:
            return { ...state, branches: action.payload }
        default:
            return state;
    }
}